module.exports = __webpack_public_path__ + "img/packaged.2bd55f83.png";